<div class="location-search-container">
  <div class="locationSearch-container" (click)="showScannerDialog()">
    <label [ngClass]="{'value-label': staticTableNo}">{{staticTableNo ? ('dinein.location.label' | translate) :
      ('location.scan.desc' | translate) }}</label>
    <h1 class="truncateText locationSearch">{{staticTableNo}}</h1>

    <app-button [iconName]="'icon-scan'" [textButton]="true" [buttonName]="'dinein.qr.change.label' | translate"
      *ngIf="staticTableNo" class="scanLocation-btn"></app-button>

    <app-button [iconName]="'icon-scan'" [textButton]="true" *ngIf="!staticTableNo"
      class="scanLocation-btn"></app-button>
  </div>
</div>
